<template>
  <div>
    <div
      v-if="data.dateVisit == '' || data.dateVisit == null || data.dateVisit == undefined"
      class="card-visit-date"
    >
      <div>
        <span class="font-w-600">วันที่เข้าเยี่ยม :</span>
        <span class="pl-5 text-blue">
          <u v-if="calendarDate == null">ระบุวันที่เข้าเยี่ยม</u>
          <u v-else>{{ calendarDate }}</u>
        </span>
        <i class="icon-Calendar icon--edit" @click="calendarModal = true"></i>

        <v-dialog
          ref="dialog"
          v-model="calendarModal"
          :return-value.sync="calendarDate"
          persistent
          width="600px"
        >
          <v-date-picker v-model="calendarDate" color="red lighten-1" width="550" class="mt-4">
            <v-spacer></v-spacer>
            <v-btn text color="primary" @click="calendarModal = false">Cancel</v-btn>
            <v-btn text color="primary" @click="saveCalendarDate(calendarDate)">OK</v-btn>
          </v-date-picker>
        </v-dialog>
      </div>
    </div>

    <div v-else class="card-visit-date">
      <div>
        <span class="font-w-600">วันที่เข้าเยี่ยม :</span>
        <span class="pl-5">{{ data.dateVisit }}</span>
        <span
          v-if="action != 'views' && planby != false"
          class="pl-5 text-blue"
          @click="dialogChangePlan = true"
        >
          <u>แก้ไขวันที่</u>
        </span>
      </div>
      <btn-visit-date
        :message="data.dateStatus"
        :backgroundColor="'#e6ffdf'"
        :textColor="'#088546'"
        :borderColor="'#bbedae'"
      ></btn-visit-date>
    </div>

    <div v-if="data.status != 0" class="card-visit-inout">
      <div class="d-flex">
        <div class="box-item-status checkin"></div>
        <div class="box-checkin">
          <span>CHECK IN:</span>
          <span>{{ data.checkInTime }} น.</span>
        </div>
      </div>
      <div class="d-flex border-line">
        <div class="box-item-status checkout"></div>
        <div class="box-checkin">
          <span>CHECK OUT:</span>
          <span v-if="data.checkOutTime != ''">{{ data.checkOutTime }} น.</span>
          <span v-else class="text-gray">ยังไม่ได้ CHECK OUT</span>
        </div>
      </div>
      <div class="d-flex border-line">
        <i class="icon-Time_His m-2"></i>
        <div class="box-checkin">
          <span>เวลาเข้าเยี่ยม:</span>
          <span v-if="data.checkTime != ''">{{ data.checkTime }} น.</span>
          <span v-else class="text-gray">ยังไม่ได้ CHECK OUT</span>
        </div>
      </div>
    </div>

    <dialog-change-plan
      v-if="dialogChangePlan"
      :dialog="dialogChangePlan"
      :date="data.dateVisitEN"
      @dialog-close="dialogChangePlan = false"
      @change-duedate="changeCalendarDate"
      @submit-duedate="submitCalendarDate"
    />
  </div>
</template>

<script>
import DialogChangePlan from '@/components/v2/calendar/DialogChangePlan.vue'
export default {
  props: ['data', 'action', 'planby'],

  emits: ['setDueDate', 'changeDueDate'],

  components: {
    DialogChangePlan
  },

  data() {
    return {
      dialogChangePlan: false,
      calendarDate: null,
      calendarModal: false
    }
  },

  methods: {
    saveCalendarDate(value) {
      this.$refs.dialog.save(value)
      this.calendarDate = value
      this.calendarModal = false
      this.$emit('setDueDate', this.calendarDate)
    },

    changeCalendarDate(date) {
      this.data.dateVisitEN = date
    },

    submitCalendarDate() {
      this.dialogChangePlan = false

      const data = {
        method: 'POST',
        headers: this.setheaders,
        body: JSON.stringify({
          visit_id: parseInt(this.data.visitID),
          date: this.data.dateVisitEN
        })
      }

      fetch(`${this.$baseAPI}/visit/change_plan`, data)
        .then((response) => {
          return response.json()
        })
        .then((res) => {
          const response = res.detail
          this.$emit('changeDueDate', response)
        })
    }
  }
}
</script>

<style scoped>
.text-gray {
  color: #8c8c8c;
}
</style>
